import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { Chip } from "~components/Chip";

export type StatusWithDateProps = {
  date?: string;
  status?: string;
};

export const StatusWithDate = ({ date, status }: StatusWithDateProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.date}>{date || ""}</div>
      <Chip color="secondary" className={classes.completed} label={status ?? "-"} />
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    completed: {
      textTransform: "uppercase",
      borderRadius: 2,
      marginLeft: theme.spacing(2),
      fontSize: 10,
      fontWeight: 600,
      letterSpacing: 0.83,
      lineHeight: 1.9,
      height: "16px",

      "& span": {
        padding: "0 4px",
      },
    },
    date: {
      lineHeight: "16px",
      textAlign: "right",
      paddingTop: 0,
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.battleshipGrey.main,
    },
  }),
);
